import { css } from '@emotion/core'
import { Cell, Grid, HFlow, Modal, ModalBody, ModalFooter, VFlow } from 'bold-ui'
import { FooterButton } from 'components/footer-button'
import { DateField, Form, FormRenderProps, TextAreaField } from 'components/form'
import { EstrategiaVacinacaoSelectField } from 'components/form/field/select/EstrategiaVacinacaoSelectField'
import { addDays } from 'date-fns'
import React from 'react'
import { metaPath } from 'util/metaPath'
import { createValidator, required } from 'util/validation'

import { RegistroVacinacaoFormModel, TipoRegistroDoseEnum } from './model'
import { VacinacaoModalHeader } from './VacinacaoModalHeader'

interface AprazamentoVacinaModalProps {
  idImunobiologico: ID
  nomeImunobiologico: string
  siglaImunobiologico: string
  idDose: ID
  nomeDose: string
  faixaEtaria: string
  modalOpen: boolean
  handleModalClose(): void
  handleOnSubmit(formValues: RegistroVacinacaoFormModel): void
}

const meta = metaPath<RegistroVacinacaoFormModel>()

const validator = createValidator<RegistroVacinacaoFormModel>({
  estrategiaVacinacao: [required],
  dataAprazamento: [required],
})

const minDate = addDays(new Date(), 1)

export const AprazamentoVacinaModal = (props: AprazamentoVacinaModalProps) => {
  const { idImunobiologico, idDose, modalOpen, handleModalClose, handleOnSubmit } = props

  const handleSubmit = (formValues: RegistroVacinacaoFormModel) => {
    formValues.tipoRegistroVacinacao = TipoRegistroDoseEnum.APRAZAMENTO
    formValues.imunobiologico = idImunobiologico
    formValues.doseImunobiologico = idDose
    handleOnSubmit(formValues)
    handleModalClose()
  }

  const renderForm = (formRenderProps: FormRenderProps<RegistroVacinacaoFormModel>) => {
    return (
      <Modal open={modalOpen} onClose={handleModalClose} size='auto' closeOnBackdropClick={false}>
        <ModalBody>
          <VFlow>
            <VacinacaoModalHeader {...props} />
            <Grid
              style={css`
                width: 36rem;
              `}
            >
              <Cell size={8}>
                <EstrategiaVacinacaoSelectField
                  name={meta.estrategiaVacinacao}
                  label='Estratégia'
                  imunobiologicoId={idImunobiologico}
                  doseImunobiologicoId={idDose}
                  required
                />
              </Cell>
              <Cell size={4}>
                <DateField
                  label='Aprazar para'
                  name={meta.dataAprazamento}
                  icon='calendarOutline'
                  minDate={minDate}
                  required
                />
              </Cell>
              <Cell size={12}>
                <TextAreaField
                  style={css`
                    height: 5rem;
                    resize: none;
                  `}
                  name={meta.observacoes}
                  label='Observações'
                  onFocus={function noRefCheck() {}}
                  maxLength={200}
                />
              </Cell>
            </Grid>
          </VFlow>
        </ModalBody>
        <ModalFooter>
          <HFlow justifyContent='flex-end'>
            <FooterButton kind='normal' onClick={handleModalClose}>
              Cancelar
            </FooterButton>
            <FooterButton kind='primary' onClick={formRenderProps.handleSubmit}>
              Salvar
            </FooterButton>
          </HFlow>
        </ModalFooter>
      </Modal>
    )
  }
  return (
    <Form<RegistroVacinacaoFormModel>
      subscription={{ submitting: true, pristine: true }}
      render={renderForm}
      validate={validator}
      onSubmit={handleSubmit}
    />
  )
}
